(function (window, document, $) {

    $(document).ready(function () {
        // Advertentie slider  =========================================================================================

        $('.advertentie-slider').on('scroll', function () {

            if ($(this).data('sliderOffset') === 1) {
                $('.slider-navigation--left-full').css({ opacity: 0 });
                $('.slider-navigation--right-full').css({ opacity: 0 });
            }

            var scrollWidth = $(this).children().outerWidth() * ($(this).data('sliderOffset') - 1);

            if ($(this).scrollLeft() > 0) {
                $('.slider-navigation--left-full').css({ opacity: 1 });
            } else {
                $('.slider-navigation--left-full').css({ opacity: 0 });
            }

            if ($(this).scrollLeft() >= scrollWidth) {
                $('.slider-navigation--right-full').css({ opacity: 0 });
            } else {
                $('.slider-navigation--right-full').css({ opacity: 1 });
            }

        });
    });

}(window, document, jQuery));
